<template>
    <div v-if="!disabled" style="margin-top: auto; margin-bottom: 10px;">
        <a v-if="statusUrl" :href="statusUrl" target="_blank" class="btn btn-secondary v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default m-l-sm">
            <i class="fa-regular fa-lightbulb fa-lg m-r-xs"></i>
            {{ translations.status }}
        </a>
        <v-btn v-if="ip && !disablePovConnectionButtons" type="button" :class="[pingActive? 'disabled' : '','btn btn-secondary m-l-sm']"
                @click.stop.prevent="ping">
            <i v-if="pingActive" class="fa-regular fa-spinner fa-spin-pulse fa-lg fa-fw m-r-xs"/>
            <i v-else class="fa-regular fa-share-nodes fa-lg fa-fw m-r-xs"/>
            {{ translations.checkOnlineStatus }}
        </v-btn>
        <v-btn v-if="ip && !disablePovConnectionButtons" type="button" :class="[tracerouteActive ? 'disabled' : '','btn btn-secondary m-l-sm']"
                @click.stop.prevent="traceroute">
            <i v-if="tracerouteActive" class="fa-regular fa-spinner fa-spin-pulse fa-lg fa-fw m-r-xs"/>
            <i v-else class="fa-regular fa-road fa-lg fa-fw m-r-xs"/>
            {{ translations.traceroute }}
        </v-btn>
        <a v-if="teamviewer" :href="'https://start.teamviewer.com/' + teamviewer" target="_blank"
           class="btn btn-secondary v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default m-l-sm">
            <i class="fa-regular fa-tv fa-lg m-r-xs"/>
            {{ translations.teamviewer }}
        </a>
        <a v-if="rdp" :href="rdpUrl" target="_blank" class="btn btn-secondary v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default m-l-sm">
            <i class="fa-regular fa-tv fa-lg m-r-xs"/>
            {{ translations.rdp }}
        </a>
    </div>
</template>
<script>
import toaster from "../../common/toaster";

export default {
        props: [
            'rdp',
            'rdpHost',
            'rdpPort',
            'ip',
            'teamviewer',
            'povPort',
            'noSupport',
            'statusUrl',
            'connectionDirect'
        ],
        data() {
            return {
                activeProject: undefined,
                pingActive: false,
                disabled: false,
                tracerouteActive: false,
                disablePovConnectionButtons: false,
            }
        },
        computed: {
            rdpUrl() {
                return 'http://' + this.rdpHost + ':' + this.rdpPort + '/?host=' + this.ip;
            },
            translations() {
                return {
                    rdp: Lang.langGet("RDP"),
                    status: Lang.langGet("Status"),
                    checkOnlineStatus: Lang.langGet("Check Online Status"),
                    traceroute: Lang.langGet("Traceroute"),
                    teamviewer: Lang.langGet("Teamviewer"),
                }
            }
        },
        methods: {
            ping() {
                this.pingActive = true;

                axios.post('/ping', {
                    host: this.ip,
                    port: this.povPort
                }).then((response) => {
                    if (parseInt(response.data.data) >= 0) {
                        toaster.success(Lang.langGet(":host is online.", {host: this.ip}));
                    } else {
                        toaster.error(Lang.langGet(":host is offline.", {host: this.ip}));
                    }
                    this.pingActive = false;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(Lang.langGet(":host is offline.", {host: this.ip}));
                    this.pingActive = false;
                });
            },
            traceroute() {
                this.tracerouteActive = true;

                axios.post('/traceroute', {
                    destination: this.ip
                }).then((response) => {
                    if (response.data.data.length > 0) {
                        EaseEventBus.fire('showTraceroute', {response: response.data.data, ip: this.ip});
                    } else {
                        toaster.error(Lang.langGet("Failed to traceroute :host.", {host: this.ip}));
                    }

                    this.tracerouteActive = false;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(Lang.langGet("Failed to traceroute :host.", {host: this.ip}));
                    this.tracerouteActive = false;
                });
            }
        },
        mounted() {
            if (!this.ip.length || this.noSupport === '1') {
                this.disabled = true;
            }

            this.disablePovConnectionButtons = (this.connectionDirect !== '1');
        }
    }
</script>
